import React from 'react';
import { ArrowRight, Flame } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const tone = (a) => (a >= 85 ? 'text-red-500' : a >= 70 ? 'text-orange-600 dark:text-orange-400' : a >= 50 ? 'text-amber-600 dark:text-amber-400' : 'text-slate-400');
const KIND = { alert: 'Alerta', opportunity: 'Oportunidad', decision: 'Decisión' };

export const PriorityRow = ({ item, rank, onNavigate, testid }) => (
  <li className="mat-reveal flex items-start gap-4 border-t border-slate-200 py-4 first:border-t-0 dark:border-slate-700"
    style={{ animationDelay: `${Math.min(rank, 10) * 50}ms` }} data-testid={testid}>
    <span className="w-8 shrink-0 pt-0.5 text-right font-mono text-2xl font-black leading-none text-slate-300 dark:text-slate-600">{rank}</span>
    <div className="min-w-0 flex-1 space-y-1">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`font-mono text-lg font-bold tabular-nums ${tone(item.attention)}`} data-testid={`${testid}-score`}>{Math.round(item.attention)}</span>
        <Badge variant="outline" className="text-[10px]">{KIND[item.kind] || item.kind}</Badge>
        {item.immediate && <Badge className="on-solid bg-red-600 text-white" data-testid={`${testid}-immediate`}><Flame className="mr-1 h-3 w-3" />Atención inmediata</Badge>}
      </div>
      <p className="font-semibold leading-snug text-slate-900 dark:text-white">{item.title}</p>
      {item.detail && <p className="text-sm text-slate-600 dark:text-slate-300">{item.detail}</p>}
      <div className="flex flex-wrap gap-1.5">{item.reasons.map((r) => <span key={r} className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] text-slate-600 dark:bg-slate-800 dark:text-slate-300">{r}</span>)}</div>
    </div>
    {onNavigate && <Button size="sm" variant="ghost" onClick={() => onNavigate(item.action.tab)} data-testid={`${testid}-action`}>
      {item.action.label}<ArrowRight className="ml-1 h-3.5 w-3.5" /></Button>}
  </li>
);
